import React, { useState, useContext, useEffect, useRef } from "react";

import "./TermsAndConditions.css";
import Markdown from "react-markdown";
import { Modal, Button, Checkbox, IconButton } from "@mui/material";
import { useDocumentAcceptanceMutation } from "../../services/documentsApi";
import CircularProgress from "@mui/material/CircularProgress";

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';

import rehypeRaw from 'rehype-raw'
import {marked} from "marked";
import html2pdf from "html2pdf.js";

import { useHistory } from "react-router-dom";
import BasicModalConfirmation from './../basicModalConfirmation';

const TermsAndConditions = ({open, handleClose, documents, user, onDocumentAccept}) => {
  const [documentIndex, setDocumentIndex] = useState(0)
  const [documentsAccepted, setDocumentsAccepted] = useState([])
  const [readConfirmation, setReadConfirmation] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [submitAcceptance] = useDocumentAcceptanceMutation()
  const [openConfirm, setOpenConfirm] = useState(false)
  const [documentFirstViewed, setDocumentFirstViewed] = useState({})

let history = useHistory();

useEffect(() => {
  const currentDocumentId = documents[documentIndex]?.id;
  if (currentDocumentId && !documentFirstViewed[currentDocumentId]) {
    const currentTimestamp = new Date().toISOString().slice(0, 19).replace('T', ' ');
    setDocumentFirstViewed(prevState => ({
      ...prevState,
      [currentDocumentId]: currentTimestamp
    }));

    (async () => {

      let submitFirstView = [
        {
          "documentId": currentDocumentId,
          "userId": user.id,
          "firstViewedOn": currentTimestamp,
          "accepted": false
        }
      ]

      try {
        await submitAcceptance(submitFirstView).unwrap();
      } catch (error) {
        console.error('Error:', error);
      }

    })();
  }
}, [documents, documentIndex]);

// useEffect(() => {
// const currentDocumentId = documents[documentIndex]?.id;
// if (currentDocumentId && !documentFirstViewed[currentDocumentId]) {
//   const currentTimestamp = new Date().toISOString().slice(0, 19).replace('T', ' ');
//   setDocumentFirstViewed(prevState => ({
//     ...prevState,
//     [currentDocumentId]: currentTimestamp
//   }));
// }
// }, [documents, documentIndex]);

  const handleAccept = async()=>{

    if (onDocumentAccept) {
      onDocumentAccept();
      handleClose();
    }

    else {

      // Set the 'fetching' state to true to indicate that a request is being made
      setFetching(true)
      // Create an array containing an object with the 'documentId' and 'userId'
      let docAccept = [
        {
          "documentId": documents[documentIndex]?.id,
          "userId": user.id,
          "firstViewedOn": documentFirstViewed[documents[documentIndex]?.id],
          "accepted": true 
      }
      ]
      // Update the 'documentsAccepted' state to include the new 'docAccept' array
      setDocumentsAccepted(prevState=>[...prevState,docAccept ])
      // Call the 'submitAcceptance' function with the 'docAccept' array as an argument
      let response
      try{
        response = await submitAcceptance(docAccept).unwrap()
      } catch (error) {
      console.log("getAvailableJobs_2 error: " + JSON.stringify(error))
      if(error.status == 401) return; //error managed on baseQueryWithReauth
      throw error
    }
      // If the response from the 'submitAcceptance' function contains the same 'id' as the 'documentId' in the 'docAccept' array,
      if(response[0]?.documentID === documents[documentIndex]?.id){
        // Increment the 'documentIndex' state
        // If the current 'documentIndex' is less than or equal to the length of the 'documentsAccepted' array, increment the 'documentIndex' by 1
        // Otherwise, leave the 'documentIndex' unchanged
        setDocumentIndex((prevState)=>{if(prevState <= documentsAccepted.length){return prevState+1} else{return prevState}})
          // Set the 'readConfirmation' state to false to indicate that the user has accepted the document
        setReadConfirmation(false)
        // Set the 'fetching' state to false
        setFetching(false)
      }
      // If the response from the 'submitAcceptance' function does not contain the same 'id' as the 'documentId' in the 'docAccept' array,
      else{
        // log an error
        console.warn(new Error("Document acceptance error: response does not contain the same id of the document acceptance request: ",response))
      }

    }
  
  }

  const logout = () => {
    localStorage.removeItem("accessToken");
    history.push("/");
    handleClose()
  }

  function ActiontButtons() {

    const handleDownload = () => {
      if (document) {
        const htmlContent = marked.parse(documents[documentIndex]?.documentContent); // Convert Markdown to HTML
        const element = window.document.createElement("div");
        element.innerHTML = htmlContent;
        element.className = "pdf-content";

        // Ensure that your HTML has styles that respect the margins
        element.style.padding = "20mm 15mm";
  
        // Set up the options for html2pdf
        const options = {
          //margin: [10, 15],
          filename: 'EncoreHive-TermsAndConditions.pdf',
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          pagebreak: { mode: 'avoid-all' } // ['avoid-all', 'css', 'legacy']
        };
        // Use the options when generating the PDF
        html2pdf().from(element).set(options).save();
        console.log("Downloading PDF");
      }
    };

    const handlePrint =() => {
      if (document) {
        const htmlContent = marked.parse(documents[documentIndex]?.documentContent); // Convert Markdown to HTML
        const printFrame = window.document.createElement('iframe');
        printFrame.setAttribute('allow-modals', 'true');
        printFrame.style.visibility = 'hidden';
        printFrame.style.position = 'fixed';
        printFrame.style.right = '0';
        printFrame.style.bottom = '0';
        window.document.body.appendChild(printFrame);
        printFrame.contentDocument.open();
        printFrame.contentDocument.write(htmlContent);
        printFrame.contentDocument.close();
        printFrame.contentWindow.focus();
        printFrame.contentWindow.print();
        window.document.body.removeChild(printFrame); // Remove the iframe after printing
      }
    }

    const onCloseClick = () => {

      if (onDocumentAccept) {
        handleClose();
      }
      else {
        setOpenConfirm(true)
      }

    }

    return (
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", height: "100%", width: "content-fit"}}>
        <div style={{margin:"0 1em 0 0" , display: "flex", justifyContent: "space-between", height: "100%", width: "content-fit"}}>
          <IconButton 
            variant="contained"
            sx={{
               
              color: "white",  
              borderRadius: "50%",
              margin: "0 0.5em 0 0",
              height: "1.6em",
              width: "1.6em"
            }}
            onClick={handleDownload} 
          >
            <FileDownloadOutlinedIcon
              sx={{
                backgroundColor: "var(--orange)",
                borderRadius: "50%",
                height: "1.6em",
                width: "1.6em",
                padding: "0.2em"
              }}
            />
          </IconButton>
          <IconButton 
            sx={{
              color: "white", 
              borderRadius: "50%",
              margin: "0 0.5em 0 0",
              height: "1.6em",
              width: "1.6em"
            }}
            onClick={handlePrint}
          >          
            <LocalPrintshopOutlinedIcon
              sx={{
                backgroundColor: "var(--orange)",
                borderRadius: "50%",
                height: "1.6em",
                width: "1.6em",
                padding: "0.2em"
              }}
            />
          </IconButton>
          </div>
        <Button disabled={fetching} variant="outlined" className="button" onClick={onCloseClick}>
          Close
        </Button>
      </div>
    );
  }
  
  useEffect(() => {
    if (documentsAccepted.length > 0 && documentsAccepted.length === documents.length && !fetching) {
      setDocumentsAccepted([]);
      handleClose();
    }
  }, [documentsAccepted, documents, fetching, handleClose]);

  // If documentIndex is equal to the length of documents, documentIndex resets to 0
  useEffect(() => {
    if (documentIndex === Object.keys(documents).length) {
        setDocumentIndex(0);
    }
  }, [documentIndex]);

// ------------------- AutoScroll ----------------------------
  const divRef = useRef(null);

  useEffect(() => {
    // with the interval you can animate the scroll but, once it executes do not stop
    //const interval = setInterval(() => {
      divRef.current && (divRef.current.scrollTop = 1)
    //}, 50);

    //return () => clearInterval(interval);
  }, [documentIndex]);
// ------------------- AutoScroll ----------------------------
  
  return (
    <>
    <BasicModalConfirmation open={openConfirm} onCloseClick={()=>setOpenConfirm(false)} handleClose={logout} title="You have not signed the required document. As a result, you will be logged out and cannot interact with the application's features.

Please sign the document to regain access. If you need assistance, contact support." />
    <Modal open={open} className="terms-and-conditions-modal">
      <div className="terms-and-conditions">

        <p className="terms-and-conditions-title" >
          Please read through the document below, scroll to the bottom, and
          click Accept to continue.
        </p>

        <div ref={divRef} className="terms-and-conditions-content">
        {
          fetching ? 
            <CircularProgress sx={{ 
              color: "#F29B1B",
              /* Center vertically and horizontally */
              position: "absolute",
              top: "50%",
              left: "50%" 
          }} />
          :
          (
            <>
                <Markdown rehypePlugins={[rehypeRaw]} children={documents[documentIndex]?.documentContent} />

                <div className="terms-and-conditions-user-input">

                  <div className="terms-and-conditions-check">
                    <Checkbox checked={readConfirmation} onChange={(e)=>setReadConfirmation(e.target.checked)}/>
                    <label>
                      I have read, understood, and accept the terms and information
                      presented here.
                    </label>
                  </div>

                  <Button disabled={!readConfirmation || fetching } variant="contained" className="button" onClick={handleAccept}>
                    Accept
                  </Button>
                </div>
              </>
            )
        }
         
        </div>
        <div className="terms-and-conditions-user-input">
          <ActiontButtons></ActiontButtons>
        </div>
      </div>
    </Modal>
    </>
  );
};

export default TermsAndConditions;